import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Outlet, useLocation, useSearchParams } from 'react-router-dom'
import Auth from '@/layout/Auth'
import Navbar from '@/layout/Navbar'
import { SnackbarProvider } from 'notistack'
import { Helmet } from 'react-helmet'
import PromotionLayout from './layout/Promotion'
import ErrorMsg from './layout/ErrorMsg'
import NotificationProvider from './layout/NotificationIO'
import Onboarding from './layout/Onboarding'
import FontProvider from './layout/FontProvider'

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false, refetchOnWindowFocus: false } },
})

const Root = () => {
  const { pathname } = useLocation()
  const [searchParams] = useSearchParams()

  if (pathname === '/console' || pathname === '/console/') {
    window.location.href = `/console/workbench?${searchParams.toString()}`
  }
  return (
    <FontProvider>
      <QueryClientProvider client={queryClient}>
        <SnackbarProvider autoHideDuration={3000} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} maxSnack={5}>
          <ErrorMsg>
            <Auth>
              <Onboarding>
                <NotificationProvider>
                  {/* <PromotionLayout> */}
                  <Helmet>
                    <title>长亭百川云平台-面向企业和技术爱好者-主机管理-云原生安全-网站监测-Web应用防火墙</title>
                  </Helmet>
                  <Navbar />
                  <Outlet />
                  {/* </PromotionLayout> */}
                </NotificationProvider>
              </Onboarding>
            </Auth>
          </ErrorMsg>
        </SnackbarProvider>
      </QueryClientProvider>
    </FontProvider>
  )
}

export default Root
